export default "__VITE_ASSET__84c14661__"